import { createContext, useEffect, useReducer } from 'react';

import { reducer } from './reducer';
import { Action, CalculationMethod, IPitchState, PlatoGravity, WortUnits } from './types';

const LOCAL_STORAGE_KEY = '__PITCH_RATE_SETTINGS__';

const initialState: IPitchState = {
  error: null,
  wortUnit: WortUnits.Hectorliter,
  gravityType: PlatoGravity.Plato,
  calculationMethod: CalculationMethod.ExcludingYeastVolume,
};

export const PitchRateContext = createContext(
  {} as { state: IPitchState; dispatch: (action: Action) => void },
);

const getInitialState = (): IPitchState => {
  const payload = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  const savedSettings = payload ? JSON.parse(payload) : initialState;
  return { ...savedSettings };
};

export const PitchRateProvider = ({ children }: { children: JSX.Element }) => {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  useEffect(() => {
    const { calculationMethod, wortUnit, gravityType } = state;
    const payload = JSON.stringify({ calculationMethod, wortUnit, gravityType });
    window.localStorage.setItem(LOCAL_STORAGE_KEY, payload);
  }, [state.calculationMethod, state.wortUnit, state.gravityType]);

  return (
    <PitchRateContext.Provider value={{ state, dispatch }}>
      {children}
    </PitchRateContext.Provider>
  );
};
